import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import displayError from '../../utils/ErrorHandler';
import UserContext from '../../contexts/UserContext';
import { useNavigate, Link } from 'react-router-dom';
import authenticate from '../../utils/Authenticate';
import { format } from 'date-fns';

const PurchaseOrder = () => {
  const [pos, setPOs] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const { user, setUser } = useContext(UserContext);
  const [loading, setLoading] = useState(true);
  const goToCreatePO = () => {
    navigate("/central/create-po");
  };
  const [viewMode, setViewMode] = useState('grid'); // 'grid' or 'list'

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URI}/api/po/getAllMasterPOs`, {
      withCredentials: true
    })
      .then(response => {
        setPOs(response.data .data|| []);
        setLoading(false);
      })
      .catch((err) => {
        const errorMessage = displayError(err, navigate, setUser);
        if (errorMessage) {
          setMessage(errorMessage);
        }
      });
  }, []);

  useEffect(() => {
    async function startup() {
      if (!user) {
        await authenticate(setUser, navigate);
      }
    }
    startup();
  }, [user, navigate, setUser]);

  const handleSearch = (e) => {
    setSearchQuery(e.target.value.toLowerCase());
  };

  const filteredPOs = pos?.filter(po =>
    po?.supplier?.toLowerCase().includes(searchQuery.toLowerCase()) 
    //||
    //po?.zone?.desc?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const filteredPurchaseOrders = pos.filter(po => {
  const query = searchQuery.toLowerCase();

  // Check supplier name
  const matchesSupplier = po.supplier?.toLowerCase().includes(query);

  // Check zone descriptions
  const matchesZone = po.po?.zones?.some(zone =>
    zone?.desc?.toLowerCase().includes(query)
  );

  return matchesSupplier || matchesZone;
});

  const sortedPOs = [...filteredPurchaseOrders].sort((a, b) => new Date(b.po.createdAt) - new Date(a.po.createdAt));
  // console.log(filteredPOs);
  const handleDownloadExcel = async () => {
  if (!pos || pos.length === 0) {
    alert("No Master POs to download.");
    return;
  }

  const masterPOIds = pos.map(po => po.po._id);

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URI}/api/po/viewMutipleConsolidatedPOExcel`,
      { ids: masterPOIds },
      {
        responseType: 'blob',
        withCredentials: true,
      }
    );

    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'Consolidated_MasterPO_Report.xlsx';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  } catch (err) {
    const errorMessage = displayError(err, navigate, setUser);
    if (errorMessage) {
      setMessage(errorMessage);
    }
  }
};






  return (
    <div className="p-4">
      { message && (
        <div className="bg-red-100 border border-red-300 text-red-500 px-4 py-3 mx-0 rounded relative" role="alert">
          <span className="block sm:inline">{message}</span>
        </div>
      )}
     {!loading &&(
      <>
      <div className="mb-4">
        <input
          type="text"
          className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-fmb"
          placeholder="Search POs by supplier or zone..."
          value={searchQuery}
          onChange={handleSearch}
        />
      </div>  
        <div className="ml-4 flex gap-2">
    <button
      onClick={() => setViewMode('grid')}
      className={`px-3 py-1 rounded ${viewMode === 'grid' ? 'bg-fmb text-white' : 'bg-gray-100 text-gray-600'}`}
    >
      Grid View
    </button>
    <button
      onClick={() => setViewMode('list')}
      className={`px-3 py-1 rounded ${viewMode === 'list' ? 'bg-fmb text-white' : 'bg-gray-100 text-gray-600'}`}
    >
      List View
    </button>
  </div>
      </>
)}

{!loading && (
  <div className="flex justify-end mb-4">
    <button
      onClick={handleDownloadExcel}
      className="bg-fmb text-white px-4 py-2 rounded-md shadow hover:bg-fmb-dark text-sm"
    >
      Download Consolidated Excel
    </button>
  </div>
)}

      {viewMode === 'grid' ? (
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {sortedPOs.map(po => (
          <Link to={`/central/masterPo/${po.po._id}`} key={po.po._id}>
            <div className="bg-white p-4 rounded-lg shadow-md border border-fmb-light hover:bg-gray-50 cursor-pointer relative">
              <h2 className="text-lg font-semibold text-fmb mb-3">
                PO #{po.po.PONumber || 'Old'}
              </h2>
              <div className="flex flex-wrap gap-2 text-xs text-gray-700">
                <span className="px-2 py-0.5 bg-blue-100 text-blue-800 rounded-full">
                  Zone Count: {po.zoneCount || 0}
                </span>
                <span className="px-2 py-0.5 bg-green-100 text-green-800 rounded-full">
                  Supplier: {po.supplier || 'Supplier N/A'}
                </span>
                {po.grn && (
                  <span className="px-2 py-0.5 bg-green-100 text-green-800 rounded-full">
                    GRN: {po.grn}
                  </span>
                )}
              </div>
            </div>
          </Link>
        ))}
      </div>
      ) : (<div className="overflow-x-auto">
    <table className="min-w-full border text-sm">
      <thead className="bg-gray-100">
        <tr>
          <th className="px-4 py-2 text-left border">PO Number</th>
          <th className="px-4 py-2 text-left border">Supplier</th>
          <th className="px-4 py-2 text-left border">Zone Count</th>
          <th className="px-4 py-2 text-left border">GRN</th>
        </tr>
      </thead>
      <tbody>
        {sortedPOs.map(po => (
          <tr
            key={po.po._id}
            className="hover:bg-gray-100 cursor-pointer"
            onClick={() => navigate(`/central/masterPo/${po.po._id}`)}
          >
            <td className="px-4 py-2 border">PO #{po.po.PONumber || 'Old'}</td>
            <td className="px-4 py-2 border">{po.supplier}</td>
            <td className="px-4 py-2 border">{po.zoneCount}</td>
            <td className="px-4 py-2 border">{po.grn || '-'}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
)}

      {/* Floating Action Button */}
      <div className="fab-container" onClick={goToCreatePO}>
        <button className="fab-button bg-fmb">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
        </button>
        <span className="fab-text text-fmb">Create New PO</span>
      </div>
    </div>
  );
};

export default PurchaseOrder;